import { IMPERSONATOR_USER_ID_STORAGE_KEY } from './constants';

/** Store the admin's own id at the start of an impersonation, guarded so a throwing storage is a no-op. */
export const persistImpersonatorUserId = (id: string): void => {
  try {
    globalThis.localStorage.setItem(IMPERSONATOR_USER_ID_STORAGE_KEY, id);
  } catch {
    // Storage unavailable: the check falls back to the parked tokens.
  }
};
